import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GeneralRoutingModule} from './general-routing.module';
import {GeneralComponent} from './general.component';
import {ApplicationFormComponent} from './application-form/application-form.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ArchwizardModule} from 'angular-archwizard';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SharedModule} from '../../shared/shared.module';
import {NgSelectModule} from '@ng-select/ng-select';
import {HttpClientModule} from '@angular/common/http';
import {ImageCropperModule} from 'ngx-image-cropper';
import {CountToModule} from 'angular-count-to';

@NgModule({
  declarations: [
    GeneralComponent,
    ApplicationFormComponent
  ],
    imports: [
        CommonModule,
        GeneralRoutingModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        NgbModule,
        ArchwizardModule,
        SharedModule,
        NgSelectModule,
        ImageCropperModule,
        CountToModule
    ]
})
export class GeneralModule {
}
